<template>
  <div class="relative flex items-center space-x-2">
    <input
      v-model="term"
      type="text"
      :placeholder="$t('search')"
      class="input input-bordered w-full max-w-sm bg-white h-10 pl-8"
      @input="searchChanged"
    />
    <MagnifyingGlassIcon class="w-5 h-5 absolute top-1/2 -translate-y-1/2" />
    <XMarkIcon
      v-if="term"
      @click="clearSearch"
      class="w-5 h-5 absolute top-1/2 -translate-y-1/2 right-1.5 transition cursor-pointer hover:text-white hover:bg-red-500/50 rounded-full"
    />
    <button v-if="authToken" class="btn text-xs btn-sm" @click="toggleHidden">
      {{ showHidden ? $t('showAll') : $t('showHidden') }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'

import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/vue/24/solid'
import debounce from 'lodash.debounce'

import { axiosInstance } from '@/utils/axios'

import type { Pin } from '@/interfaces'

const emit = defineEmits<{
  (e: 'result', value: Pin[]): void
  (e: 'clear'): void
  (e: 'toggle-hidden', value: boolean): void
}>()

const term = ref('')
const authToken = ref('')
const showHidden = ref(false)

onMounted(() => {
  const storedToken = sessionStorage.getItem('authToken')

  authToken.value = storedToken ? storedToken : ''
})

const searchChanged = debounce(async () => {
  if (term.value.length > 2) {
    const authToken = sessionStorage.getItem('authToken')

    const res = await axiosInstance.get('activities/search', {
      ...(authToken && { headers: { 'x-auth-token': authToken } }),
      params: { term: term.value }
    })

    emit('result', res.data)
  }
}, 500)

const clearSearch = () => {
  term.value = ''
  emit('clear')
}

const toggleHidden = () => {
  showHidden.value = !showHidden.value
  emit('toggle-hidden', showHidden.value)
}
</script>
